export const ERRORS_ORDER_SERVICE: Record<string, (data?: string[]) => string> =
  {
    'work order cannot be activated.': (data?: string[]) =>
      `Ordem de serviço não pode ser ativada, remova os seguintes itens: ${data?.join(
        ',',
      )}`,
  }
